import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getMessaging, isSupported } from 'firebase/messaging'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'

// WICHTIG: Ersetze diese Werte mit deiner Firebase-Projektkonfiguration
// Firebase Console > Projekteinstellungen > Deine Apps > Web-App
const firebaseConfig = {
  apiKey: "AIzaSyCdWnuSG2MjdYSdYLEjZ6Iaf1pi6lQWkIc",
  authDomain: "minicar-f273d.firebaseapp.com",
  projectId: "minicar-f273d",
  storageBucket: "minicar-f273d.firebasestorage.app",
  messagingSenderId: "328345735946",
  appId: "1:328345735946:web:1c14bad95263e96609a0f3"
}

const app = initializeApp(firebaseConfig)

// ── Firebase App Check ──
// Schützt Firebase-Services (Auth, Firestore, Functions) vor Missbrauch durch
// Requests, die nicht von dieser legitimen App stammen. Essenziell vor Phone Auth,
// sonst kann jemand die SMS-OTP-Endpoints fremdsteuern und Kosten verursachen.
//
// Lokale Entwicklung: Debug-Token wird in der Browser-Konsole ausgegeben.
// Diesen Token in Firebase Console → App Check → "Debug-Tokens verwalten" eintragen.
//
// Produktion: reCAPTCHA Enterprise Site Key via Env-Variable.
// Site Key in Firebase Console → App Check → Web-App → reCAPTCHA Enterprise abrufen.
if (typeof window !== 'undefined') {
  if (import.meta.env.DEV) {
    // Debug-Token für lokale Entwicklung aktivieren — Token wird beim ersten
    // Firebase-Call in die Browser-Konsole geschrieben und muss dann in
    // Firebase Console → App Check → "Debug-Tokens verwalten" eingetragen werden.
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
  }
  const siteKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY
  if (siteKey) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(siteKey),
        isTokenAutoRefreshEnabled: true
      })
    } catch (err) {
      console.warn('[AppCheck] Initialisierung fehlgeschlagen:', err)
    }
  } else if (!import.meta.env.DEV) {
    console.warn('[AppCheck] VITE_RECAPTCHA_ENTERPRISE_SITE_KEY nicht gesetzt – App Check deaktiviert.')
  }
}

export const db = getFirestore(app)
export const auth = getAuth(app)

if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
}

// Messaging nur wenn unterstützt (nicht in allen Browsern)
export const getMessagingInstance = async () => {
  const supported = await isSupported()
  if (supported) return getMessaging(app)
  return null
}

export default app
